import { render, staticRenderFns } from "./IconChat.vue?vue&type=template&id=40fdae4d&scoped=true&"
import script from "./IconChat.vue?vue&type=script&lang=ts&"
export * from "./IconChat.vue?vue&type=script&lang=ts&"
import style0 from "./IconChat.vue?vue&type=style&index=0&id=40fdae4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fdae4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
